import { render, staticRenderFns } from "./filter-order-pusat-modal.vue?vue&type=template&id=47cd8244&"
import script from "./filter-order-pusat-modal.vue?vue&type=script&lang=js&"
export * from "./filter-order-pusat-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports